import { useCallback, useMemo } from 'react';
import { useFullLessonChirp } from '../lessons/lessonQueries';
import { useFullChirpTrack } from '../tracks/tracksQueries';
import { useVideoPlayerConfig } from './videoHooks';
import { isVideoAsset } from '../tracks/tracksUtils';
const getVideoAsset = asset => {
  const isVideo = asset && isVideoAsset(asset);
  if (isVideo) {
    return asset;
  }
  return {};
};
export const useVideo = ({
  contentId,
  lessonId,
  trackId
}) => {
  var _parentContent$useCas, _parentContent$busine;
  const {
    lesson
  } = useFullLessonChirp({
    lessonId: Number(lessonId),
    skip: !lessonId,
    fetchPolicy: trackId ? 'cache-only' : 'cache-first'
  });
  const {
    track
  } = useFullChirpTrack(Number(trackId));
  const getLessonVideo = useCallback(() => {
    var _lesson$content, _lesson$content2;
    if (!lesson) return undefined;
    if (contentId) return (_lesson$content = lesson.content) === null || _lesson$content === void 0 ? void 0 : _lesson$content.find(content => content.id === Number(contentId));
    const firstVideoContent = (_lesson$content2 = lesson.content) === null || _lesson$content2 === void 0 ? void 0 : _lesson$content2.find(content => isVideoAsset(content) && content.reference);
    if (!firstVideoContent) return undefined;
    return firstVideoContent;
  }, [contentId, lesson]);
  const getTrackVideo = useCallback(() => {
    if (track) {
      let firstLessonVideoContent = undefined;
      if (track.lessons) {
        for (const trackLesson of track.lessons) {
          var _trackLesson$content;
          firstLessonVideoContent = (_trackLesson$content = trackLesson.content) === null || _trackLesson$content === void 0 ? void 0 : _trackLesson$content.find(content => isVideoAsset(content) && content.reference);
          if (firstLessonVideoContent) break;
        }
      }
      if (track.introVideo) return track.introVideo;else if (firstLessonVideoContent) return firstLessonVideoContent;else return undefined;
    }
    return undefined;
  }, [track]);
  const video = useMemo(() => lessonId ? getLessonVideo() : getTrackVideo(), [getLessonVideo, getTrackVideo, lessonId]);
  const parentContent = lesson || track;
  const useCases = (_parentContent$useCas = parentContent === null || parentContent === void 0 ? void 0 : parentContent.useCases) !== null && _parentContent$useCas !== void 0 ? _parentContent$useCas : [];
  const businessObjectives = (_parentContent$busine = parentContent === null || parentContent === void 0 ? void 0 : parentContent.businessObjectives) !== null && _parentContent$busine !== void 0 ? _parentContent$busine : [];
  const {
    autoPlay,
    playSpeed
  } = useVideoPlayerConfig();
  const videoAsset = getVideoAsset(video);
  return {
    videoId: videoAsset === null || videoAsset === void 0 ? void 0 : videoAsset.reference,
    autoPlay,
    playSpeed,
    creatorHubId: videoAsset === null || videoAsset === void 0 ? void 0 : videoAsset.hubId,
    videoDuration: videoAsset === null || videoAsset === void 0 ? void 0 : videoAsset.duration,
    businessObjectives,
    useCases,
    creatorRegion: videoAsset === null || videoAsset === void 0 ? void 0 : videoAsset.hublet,
    visibility: parentContent === null || parentContent === void 0 ? void 0 : parentContent.visibility
  };
};